import { Model } from './model';

export class User extends Model {
  username: string;
  password: string;

  constructor(values: Object = {}) {
    super(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/user.ts